module.exports = __webpack_public_path__ + "assets/f0a7d77667074481648e3fecef35f0e8.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-MediumItalic.woff
 ** module id = 1739
 ** module chunks = 1
 **/